import { useTranslation } from "react-i18next";
import { AuthLayout } from "../components/layout/AuthLayout.js";
import { Button } from "../components/ui/Button.js";

export function OfflinePage() {
  const { t } = useTranslation();
  return (
    <AuthLayout title={t("offline.title")} subtitle={t("offline.message")}>
      <Button
        size="large"
        className="w-full"
        onClick={() => window.location.reload()}
      >
        {t("offline.retry")}
      </Button>
    </AuthLayout>
  );
}
